module.exports = __webpack_public_path__ + "static/img/ic_aipoint_s.aa8fe151.svg";